const entrepreneurship = `Ihmiset voivat valita, työskentelevätkö yrityksessä ja saavat palkkaa tai perustavat oman yrityksen.
Molemmissa vaihtoehdoissa on hyviä ja ei niin hyviä asioita.
Kun työskentelet yrityksessä, voit saada tasaista palkkaa ja etuja, kuten sairausvakuutusta ja loma-aikaa.
Olet myös määrittänyt työajat, jotka voivat auttaa sinua suunnittelemaan päivääsi.
Sinulla saattaa kuitenkin olla vähemmän vapautta tehdä päätöksiä ja tehdä asioita haluamallasi tavalla.
Oman yrityksen perustaminen voi olla jännittävää, sillä voit tehdä omia päätöksiäsi ja olla oma pomosi.
Sinulla on mahdollisuus ansaita enemmän rahaa, jos yrityksesi menee hyvin.
Se voi kuitenkin olla riskialtista, koska et ehkä ansaitse rahaa aluksi ja sinun on hoidettava kaikki itse, mikä voi olla haastavaa.
Jokaisella vaihtoehdolla on omat etunsa ja haittansa.
Jotkut saattavat pitää parempana palkkatyön vakautta, kun taas toiset voivat nauttia yrittäjyyden vapaudesta ja haasteista.
On tärkeää miettiä, mikä toimii parhaiten sinulle ja tavoitteillesi`;

export default entrepreneurship;